import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { ChangeCompanyGroup, CompanyGroup, CompanyGroupItemsQuery, CompanyGroupsQuery, GroupItem } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class CustomerCompanyGroupsApi {
  getGroups(query: CompanyGroupsQuery): Promise<Page<CompanyGroup>> {
    return api.get<Page<CompanyGroup>>(
      `/v1/groups`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } }).then(x => x.data);
  }

  getGroup(id: string): Promise<CompanyGroup> {
    return api.get<CompanyGroup>(`/v1/groups/${id}`, getRequestConfig())
      .then(x => x.data);
  }

  createGroup(model: ChangeCompanyGroup): Promise<string> {
    return api.post<string>(`/v1/groups`, model, getRequestConfig())
      .then(x => x.data);
  }

  changeGroup(id: string, model: ChangeCompanyGroup): Promise<any> {
    return api.put<any>(`/v1/groups/${id}`, model, getRequestConfig())
      .then(x => x.data);
  }

  deleteGroup(id: string): Promise<any> {
    return api.delete(`/v1/groups/${id}`, getRequestConfig());
  }

  getGroupItems(id: string, query: CompanyGroupItemsQuery): Promise<Page<GroupItem>> {
    return api.get<Page<CompanyGroup>>(
      `/v1/groups/${id}/items`,
      { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  addGroupItem(id: string, customerId: string): Promise<string> {
    return api.post<string>(
      `/v1/groups/${id}/items`,
      JSON.stringify(customerId),
      { ...getRequestConfig(), headers: { 'Content-Type': 'application/json' } })
      .then(x => x.data);
  }

  deleteGroupItem(id: string, itemId: string): Promise<any> {
    return api.delete(`/v1/groups/${id}/items/${itemId}`, getRequestConfig());
  }
}

export default new CustomerCompanyGroupsApi();